import { render, staticRenderFns } from "./ConfigurationHeader.vue?vue&type=template&id=39711916&scoped=true"
import script from "./ConfigurationHeader.vue?vue&type=script&lang=js"
export * from "./ConfigurationHeader.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationHeader.vue?vue&type=style&index=0&id=39711916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39711916",
  null
  
)

export default component.exports